import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RatingModal from 'components/StarRating/RatingModal';
import { resetSession, userSession } from 'state/session';
import DgaEndModal from 'components/DgaModals/DgaEndModal';

export default function GoodbyeRoute() {
  const [showDgaModal, setShowDgaModal] = useState(false);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const session = userSession().useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (session?.dgaLink) {
      setShowDgaModal(true);
    } else {
      setShowRatingModal(true);
    }
  }, [session?.dgaLink]);

  const handleDgaClose = () => {
    setShowDgaModal(false);
    setShowRatingModal(true);
  };

  const handleRatingClose = () => {
    setShowRatingModal(false);
    resetSession();
    navigate(`/${session.brand}/${session.market}/`);
  };

  return (
    <>
      {showDgaModal && <DgaEndModal onModalClose={handleDgaClose} />}
      {showRatingModal && <RatingModal onModalClose={handleRatingClose} />}
    </>
  );
}
